import { FuncKeywordDefinition } from "ajv";

const def: FuncKeywordDefinition  = {
    keyword: "markdownDescription",
    schemaType: "string",
    valid: true,
};

export default def;